import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations, type Lang } from './translations';

interface LangContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

const LangContext = createContext<LangContextType>({
  lang: 'fr',
  setLang: () => {},
  t: (key) => key,
});

function getInitialLang(): Lang {
  const stored = localStorage.getItem('riddim-lang');
  if (stored && (stored === 'fr' || stored === 'en' || stored === 'nl')) return stored;
  return 'fr';
}

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Lang>(getInitialLang);

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    localStorage.setItem('riddim-lang', l);
  }, []);

  const t = useCallback((key: string, params?: Record<string, string | number>): string => {
    let str = translations[lang][key] || translations['fr'][key] || key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        str = str.replace(`{${k}}`, String(v));
      }
    }
    return str;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export type { Lang };
